import { StoreContext } from "@roc/feature-app-core";
import { useContext } from "react";
import { DenialOfCreditRequestStore } from "../stores/denialOfCreditRequestStore";

export const useDenialOfCreditStore = () => useContext<{
  denialOfCreditRequestStore: DenialOfCreditRequestStore
}>(StoreContext);